import CardsList from "@components/Features/catalog/cards-list/cards-list";
import { CustomLoader } from "@shared/ui/CustomLoader";
import { SimilarProductsListProps } from "./types";
import classes from "./similar-products.module.scss";

export const SimilarProducts = ({ data, isLoading }: SimilarProductsListProps) => {
    return (
        <div className={classes["similar-products"]}>
            <h2 className={classes["similar-products__title"]}>Похожие объявления</h2>
            {isLoading ? (
                <CustomLoader />
            ) : data?.length ? (
                <CardsList productsData={data} />
            ) : (
                <div className={classes["similar-products__empty"]}>
                    Похожие объявления не найдены
                </div>
            )}
        </div>
    );
};